import { Validator } from 'vee-validate'
import {required} from 'vee-validate/dist/rules.esm'

export default {
  name: 'Nif',
  inject: {
    $validator: '$validator'
  },
  props: {
    placeholder: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true,
      min:10,
    },
    isNifUnique: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      nifData: parseInt(this.value, 10)
    }
  },
  watch: {
    value (val) {
      this.nifData = parseInt(val, 10)
    }
  },
  created () {
    const isNif = (value) => {
      if (value.toString().length !== 9) {
        return false
      }

      value = value.toString()
      const firstNumber = value.substring(0, 1) * 9
      const secondNumber = value.substring(1, 2) * 8
      const thirdNumber = value.substring(2, 3) * 7
      const fourNumber = value.substring(3, 4) * 6
      const fiveNumber = value.substring(4, 5) * 5
      const sixNumber = value.substring(5, 6) * 4
      const sevenNumber = value.substring(6, 7) * 3
      const eightNumber = value.substring(7, 8) * 2
      const nineNumber = value.substring(8, 9)

      let checkDigit
      const formula = parseFloat(firstNumber +
                    secondNumber +
                    thirdNumber +
                    fourNumber +
                    fiveNumber +
                    sixNumber +
                    sevenNumber +
                    eightNumber) % 11

      if (value.toString().length < 9) {
        return false
      }

      if (formula <= 1) {
        checkDigit = 0
      } else {
        checkDigit = 11 - formula
      }

      if (checkDigit !== parseInt(nineNumber, 10)) {
        return false
      }

      return value
    }
    const isNifUnique = (value) => {
      return this.$http.get(`checkNif/${value}`).then((response) => {
        return {
          valid: response.body.unique,
          data: {
            message: 'Your nif is not unique'
          }
        }
      })
    }
    Validator.extend('uniqueNif', {
      validate: isNifUnique,
      getMessage: (field, params, data) => {
        return 'Invalid fiscal number'
      }
    })


    Validator.extend('numeric', {
      validate: isNif,
      getMessage: (field, params, data) => {
        return 'Invalid fiscal number'
      }
    })
    Validator.extend('required', {
      validate: required,
      getMessage: (field, params, data) => {
        return 'Nif is required'
      }
    })
  },
  methods: {
    emitValue (event) {
      this.nifData = parseInt(event.target.value, 10)
      this.$emit('input', parseInt(this.nifData, 10))
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/component/inputs/nif/nif.js